// extracted by mini-css-extract-plugin
module.exports = {"content":"Tsj32qDTojzWDlsR4ToU"};